"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_battery__really__low(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e6cf2ade-7102-4e78-bab3-2b3c1fe027d4",
    "data-name": "battery-hi",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b7c3d82c-2ab7-4b41-a166-7d4921e6b9ec",
    x1: 149.66,
    y1: 88.99,
    x2: 174.81,
    y2: 114.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "battery-really-low-hi"), /*#__PURE__*/React.createElement("g", {
    id: "e3eef39f-9192-4815-b7cb-fb4b7dad20bc",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f3bdfd36-e76a-4846-9465-2c701ada2cd4",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b63c3868-3a4f-40de-8e19-2cfb4bb6def5",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6beecd80-b7bb-40bf-ad08-5f6da0015ccf",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8e194bf1-09fc-49d4-ac9c-58448bf2ed81",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b895dee1-73c4-45ee-a3aa-191760d79802",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16c5854c-b92b-4592-aa46-e99fb0b4e94e",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7ca3317a-fd14-4e51-a31b-58c44ab93f3a",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,84V72a16,16,0,0,0-16-16H32A16,16,0,0,0,16,72v48a16,16,0,0,0,16,16H144a16,16,0,0,0,16-16V84Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,120h4a12,12,0,0,0,12-12V84a12,12,0,0,0-12-12h-4",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160,120h4a12,12,0,0,0,12-12V84a12,12,0,0,0-12-12h-4",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160,120h4a12,12,0,0,0,12-12V84a12,12,0,0,0-12-12h-4",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 108,
    x2: 44,
    y2: 84,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,120a12,12,0,0,0,12-12V94.65l-16-16V120Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#b7c3d82c-2ab7-4b41-a166-7d4921e6b9ec)"
  }))))))))), /*#__PURE__*/React.createElement("path", {
    d: "M144,134H32a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H144a16,16,0,0,0,16-16v-2A16,16,0,0,1,144,134Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,118h-4v2h4a12,12,0,0,0,12-12v-2A12,12,0,0,1,164,118Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }));
}

var _default = ic_battery__really__low;
exports.default = _default;